import { createStackNavigator } from '@react-navigation/stack'
import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { useCompaniesContext } from 'company/context'
import { useUserCompanies } from 'company/queries/user_companies'
import React from 'react'
import Spinner from 'shared/components/spinner'
import { SelectCompanyScreen } from '../../select_company'
import { ChooseMembersScreen } from '../choose_members/screen'
import { CreateGroupScreen } from '../create/screen'
import { CreateGroupParamList } from './types'

const Stack = createStackNavigator<CreateGroupParamList>()

export function CustomGroupStack() {
  const { theme } = useTheme()
  const { companies: contextCompanies } = useCompaniesContext()
  const {
    data: userCompanies,
    isLoading,
    isError,
    isSuccess,
  } = useUserCompanies()

  if (isLoading) {
    return <Spinner />
  }

  const availableCompanies =
    isSuccess && (userCompanies?.length ?? 0) > 0
      ? userCompanies
      : contextCompanies ?? []

  const userBelongsToMultipleCompanies = availableCompanies.length > 1

  // If user companies request fails, continue with single-company flow instead of
  // unmounting this stack and crashing navigation.
  const initialRouteName =
    userBelongsToMultipleCompanies && !isError
      ? 'select_company'
      : 'choose_members'

  return (
    <Stack.Navigator
      initialRouteName={initialRouteName}
      screenOptions={() => ({
        cardStyle: { backgroundColor: theme.colors?.white },
        headerTintColor: theme.colors?.primary,
        headerBackTruncatedTitle: t('back'),
        headerTitleAlign: 'left',
        headerBackButtonDisplayMode: 'minimal',
      })}
    >
      {userBelongsToMultipleCompanies && !isError && (
        <Stack.Screen
          component={SelectCompanyScreen}
          name="select_company"
          options={{
            title: t('selectCompany'),
            headerBackTitle: t('back'),
          }}
        />
      )}
      <Stack.Screen
        component={ChooseMembersScreen}
        name="choose_members"
        options={() => ({
          title: t('addMembers'),
        })}
      />
      <Stack.Screen
        component={CreateGroupScreen}
        name="create_group"
        options={() => ({
          title: t('newGroup'),
        })}
      />
    </Stack.Navigator>
  )
}
